import * as whiteLabelingActions from './white-labeling.actions';
export const wlbActions = {
  load: whiteLabelingActions.loadWhiteLabeling,
  success: whiteLabelingActions.whiteLabelingSuccess,
  failure: whiteLabelingActions.whiteLabelingFailure,
};